import React, { useContext, useEffect, useState } from "react";
import { API_URL } from "../../components/api";
import AuthContext from "../../context/AuthContext";
import axios from "axios";

function EditingInvoices({ invoice, onClose, onSaved }) {
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [discount, setDiscount] = useState(invoice?.discount ?? 0);

  useEffect(() => {
    setDiscount(invoice?.discount ?? 0);
  }, [invoice]);

  if (!invoice) {
    return null;
  }

  const totalAmount = Number(invoice.total_amount || 0);

  const handleDiscountChange = (e) => {
    if (e.target.value === "") {
      setDiscount("");
      return;
    }

    const value = Number(e.target.value);

    if (!Number.isFinite(value) || value < 0) {
      return;
    }

    setDiscount(Math.min(value, totalAmount));
  };

  const handleSaveChanges = async () => {
    const normalizedDiscount =
      discount === "" ? 0 : Number(discount);

    if (
      !Number.isFinite(normalizedDiscount) ||
      normalizedDiscount < 0 ||
      normalizedDiscount > totalAmount
    ) {
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/inventory/invoices/`,
        {
          invoice_id: invoice.invoice_id,
          total_amount: invoice.total_amount,
          discount: normalizedDiscount,
          userdealer: user.username,
          note: invoice.note || "-",
          Action: "Put",
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        if (onSaved) {
          await onSaved();
        }

        if (onClose) {
          onClose();
        }
      }
    } catch (error) {
      console.error("Error updating invoice:", error);
    }
  };

  return (
    <div className="system-invoice-discount-editor">
      <div className="system-invoice-discount-summary">
        <div>
          <span>Invoice ID</span>
          <strong>{invoice.invoice_id}</strong>
        </div>
        <div>
          <span>Total Amount</span>
          <strong>${totalAmount.toFixed(2)}</strong>
        </div>
        <div>
          <span>Current Discount</span>
          <strong>
            ${Number(invoice.discount || 0).toFixed(2)}
          </strong>
        </div>
      </div>

      <div className="form-group system-invoice-discount-field">
        <label htmlFor="system-invoice-discount">
          Discount
        </label>
        <input
          id="system-invoice-discount"
          type="number"
          className="form-control"
          value={discount}
          onChange={handleDiscountChange}
          min="0"
          max={totalAmount}
          step="0.01"
        />
      </div>

      <div className="system-invoice-editor-actions">
        <button
          type="button"
          className="edit-client system-invoice-action-button"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className="edit-client system-invoice-action-button"
          onClick={handleSaveChanges}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}

export default EditingInvoices;
